export default "__VITE_ASSET__CDTl6PYH__"